document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('CapoteRegionSearch');
  const searchIcon = document.querySelector('.capote-region-gate__search-icon');
  const countryButtons = document.querySelectorAll('.capote-country-button');
  const regionGroups = document.querySelectorAll('[data-region-group]');

  function updateSearchIcon() {
    if (!searchInput || !searchIcon) return;

    if (searchInput.value.trim().length > 0) {
      searchIcon.classList.add('is-clear');
    } else {
      searchIcon.classList.remove('is-clear');
    }
  }

  function filterCountries() {
    if (!searchInput) return;

    const query = searchInput.value.trim().toLowerCase();

    countryButtons.forEach((button) => {
      const name = (button.dataset.countryName || '').toLowerCase();
      button.style.display = !query || name.includes(query) ? '' : 'none';
    });

    regionGroups.forEach((group) => {
      const visibleButtons = Array.from(
        group.querySelectorAll('.capote-country-button')
      ).filter((button) => button.style.display !== 'none');

      group.style.display = visibleButtons.length ? '' : 'none';

      if (query && visibleButtons.length) {
        group.classList.add('is-open');
      }
    });

    updateSearchIcon();
  }

  regionGroups.forEach((group) => {
    const toggle = group.querySelector('[data-region-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      group.classList.toggle('is-open');
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', filterCountries);
    updateSearchIcon();
  }

  if (searchIcon && searchInput) {
    searchIcon.addEventListener('click', () => {
      if (!searchInput.value.trim()) return;

      searchInput.value = '';
      filterCountries();
      searchInput.focus();
    });
  }

  countryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const countryCode = button.dataset.countryCode || '';
      const localeCode = button.dataset.localeCode || 'en';

      try {
        localStorage.setItem('capote_region_selected', 'true');
        localStorage.setItem('capote_selected_country', countryCode);
        localStorage.setItem('capote_selected_locale', localeCode);
      } catch (e) {}

      window.location.href =
        '/?country=' +
        encodeURIComponent(countryCode) +
        '&locale=' +
        encodeURIComponent(localeCode);
    });
  });
});